import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Container, Row } from "reactstrap";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import { AuthContext } from "../../context/AuthContext";
import Dashboard from "../../components/Dashboard/Dashboard";
import "./MyDocuments.css";
import MenuTop from "../../components/MenuTop/MenuTop";
import PdfEditor from "../../components/PdfEditor/PdfEditor";
import TableDocumentsWithSigners from "../../components/TableDocumentsWithSigners/TableDocumentsWithSigners";
import { DocumentTypeContext } from "../../context/DocumentContext";
import { useNavigate } from "react-router-dom";
import ModalConfirm from "../../components/ModalConfirm/ModalConfirm";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import PaginationMaterial from "../../components/PaginationMaterial/PaginationMaterial";
import ModalSignerLinks from "../../components/ModalSignerLinks/ModalSignerLinks";
import { SettingsContext } from "../../context/SettingsContext";
import { UserToken } from "../../context/hooks/useAuth";
import { jwtDecode } from "jwt-decode";

const MyDocuments = () => {
  const {
    getDocuments,
    tableDocuments,
    deleteDocumentSignType,
    downloadDocument,
    totalDocuments,
    setDocument,
  } = useContext(DocumentTypeContext);
  const navigate = useNavigate();
  const [openModalDelete, setOpenModalDelete] = useState({
    open: false,
    idDelete: "",
  });
  const [openModalLinks, setOpenModalLinks] = useState({
    open: false,
    documentId: "",
  });

  let objUserTk: UserToken;
  if (localStorage.getItem("token")) {
    objUserTk = jwtDecode(localStorage.getItem("token") || "");
  } else {
    objUserTk = {} as UserToken;
  }

  const editItem = (id: any) => {
    navigate(`/admin/add-signatories?edit=${id}`);
  };

  const viewDocument = (id: any) => {
    navigate(`/admin/sign-document?documentId=${id}`);
  };

  const signDocumentToUser = (id: any) => {
    navigate(`/admin/sign-document?documentId=${id}&sign=true`);
  };

  const removeItem = async () => {
    await deleteDocumentSignType(openModalDelete.idDelete);
    setOpenModalDelete({ open: false, idDelete: "" });
  };

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];

    if (file && file.type === "application/pdf") {
      try {
        const base64 = await toBase64(file);
        setDocument(base64);
        navigate("/admin/add-signatories");
      } catch (error) {
        console.error("Erro ao converter o arquivo para Base64:", error);
      }
    } else {
      alert("Por favor, selecione um arquivo PDF.");
    }
  };

  const getDocumentsPage = async (page: number) => {
    console.log(`Fetching documents for page ${page}`);
    await getDocuments(page);
  };

  const toBase64 = (file: File): Promise<string> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });

  useEffect(() => {
    const getData = async () => {
      await getDocuments(1);
    };
    getData();
  }, []);

  return (
    <>
      <LoadingSpinner />

      <MenuTop />

      <div
        className="mt-3 ml-3 mr-2 pt-4 pb-4 pl-4 pr-4 d-flex"
        style={{
          height: "100%",
          backgroundColor: "#fff",
          gap: "20px",
          flexDirection: "column",
          borderRadius: "12px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
        }}
      >
        <div className="d-flex" style={{ alignItems: "center", gap: "17px" }}>
          <span className="title-page-document">MEUS CONTRATOS</span>
          <label htmlFor="file-upload" className="icon-upload-document">
            <CloudUploadOutlinedIcon
              style={{ color: "#fff", cursor: "pointer" }}
            />
          </label>
          <input
            id="file-upload"
            type="file"
            accept="application/pdf"
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
        </div>

        <hr className="my-2" style={{ color: "#DDD", width: "100%" }} />
        
        <div style={{ overflowX: "auto" }}>
          <TableDocumentsWithSigners
            rows={tableDocuments}
            editItem={editItem}
            viewDocument={viewDocument}
            downloadDocument={downloadDocument}
            signDocumentToUser={signDocumentToUser}
            resendEmail={(row: any) => setOpenModalLinks({ open: true, documentId: row.id })}
            copySignerLinks={(id: string) => setOpenModalLinks({ open: true, documentId: id })}
            removeItem={(id: any) =>
              setOpenModalDelete({
                open: true,
                idDelete: id,
              })
            }
          />
        </div>

        {tableDocuments.length > 0 && (
          <div className="d-flex justify-content-end pb-2 pr-2">
            <PaginationMaterial
              onChange={(e: any, page: number) => getDocumentsPage(page || 0)}
              count={totalDocuments}
            />
          </div>
        )}
      </div>
      
      <ModalConfirm
        openModal={openModalDelete.open}
        closeModal={() => setOpenModalDelete({ open: false, idDelete: "" })}
        handleConfirm={removeItem}
      />
      <ModalSignerLinks
        openModal={openModalLinks}
        closeModal={() => setOpenModalLinks({ open: false, documentId: "" })}
      />
    </>
  );
};

export default MyDocuments;